import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useInstantiateEnterpriseRisk } from '@/hooks/mutations/enterprise-risk';

import { ModalForm } from '../form/form/ModalForm';
import InstantiateEnterpriseRiskForm from './InstantiateEnterpriseRiskForm';
import type { SchemaFields } from './schema';
import { schema } from './schema';

interface Props {
  enterpriseRiskIds: string[];
  isVisible: boolean;
  onDismiss: () => void;
}

const InstantiateEnterpriseRiskModal: FC<Props> = ({
  isVisible,
  onDismiss,
  enterpriseRiskIds,
}) => {
  const { t } = useTranslation(['common']);

  const { instantiateEnterpriseRisk } = useInstantiateEnterpriseRisk();

  const onSubmit = async (data: SchemaFields) => {
    await instantiateEnterpriseRisk({
      EnterpriseRiskIds: enterpriseRiskIds,
      Entities: data.Entities.map((e) => e.value),
    });
  };

  return (
    <ModalForm<SchemaFields>
      onDismiss={onDismiss}
      visible={isVisible}
      values={{ Entities: [] }}
      size={'max'}
      onSave={onSubmit}
      formId={'instantiateEnterpriseRisk'}
      schema={schema}
      i18n={t('enterpriseRisks')}
      defaultValues={{ Entities: [] }}
      header={t('enterpriseRisks.instantiateModal.header')}
    >
      <InstantiateEnterpriseRiskForm />
    </ModalForm>
  );
};

export default InstantiateEnterpriseRiskModal;
